// extracted by mini-css-extract-plugin
export default {"primary":"styles-module__primary__src-labstep-web-components-Experiment-Card-_sAQnt"};